// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"440":"508685e0","706":"9ec43779","823":"42498b62"}[chunkId] + ".css";
};